import { createStore } from "vuex";

export default createStore({
  state: {
    user: null,
    authInitialized: false,
    darkMode: localStorage.getItem("darkMode") === "true",
  },
  getters: {
    isAuthenticated: (state) => !!state.user,
    currentUser: (state) => state.user,
    isAuthInitialized: (state) => state.authInitialized,
    isDarkMode: (state) => state.darkMode,
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setAuthInitialized(state, initialized) {
      state.authInitialized = initialized;
    },
    setDarkMode(state, isDarkMode) {
      state.darkMode = isDarkMode;
      localStorage.setItem("darkMode", isDarkMode);
    },
  },
  actions: {
    updateUser({ commit }, user) {
      commit("setUser", user);
    },
    initializeAuth({ commit }) {
      commit("setAuthInitialized", true);
    },
    toggleDarkMode({ commit, state }) {
      commit("setDarkMode", !state.darkMode);
    },
    initDarkMode({ commit, state }) {
      // Check for system preference if no preference is stored
      if (localStorage.getItem("darkMode") === null) {
        const prefersDark = window.matchMedia(
          "(prefers-color-scheme: dark)",
        ).matches;
        commit("setDarkMode", prefersDark);
      }

      // Apply dark mode class to html element
      document.documentElement.classList.toggle("dark", state.darkMode);
    },
  },
  modules: {},
});
